export default __webpack_public_path__ + "static/media/1516 spice rack side.cc7e3ee2.png";